import { ArcadeIconNames } from './ArcadeIcon'
import { ArcadePaymentIconNames } from './ArcadePaymentIcon'
import type { OptionalRecord } from './iconMappings.generated'

export const ARCADE_ICON_VIEWBOX_MAPPING: OptionalRecord<ArcadeIconNames | ArcadePaymentIconNames, string> = {
  ShoppingCart: '0.5 3.0 22.5 19.0',
  MenuAfterpay: '2.5 3.5 19.0 17.0',
  Borrow: '2.0 1.5 20.0 18.5',
  NoCreditCheck: '0.5 3.0 23.0 16.7',
  HsaCard: '1.5 3.0 21.5 17.0',
  Fast: '1.8 3.0 20.2 18.2',
  Limits: '3.0 3.5 18.0 17.0',
  Zero: '2.3 2.3 19.4 19.4',
  Add: '2.0 2.0 20.0 20.0',
  TickerDown: '2.5 1.5 11.0 14.0',
  TickerUp: '2.5 1.5 11.0 14.0',
  BankAccount: '1.5 2.7 21.0 18.3',
  Date: '3.0 3.0 18.0 18.0',
  CameraFill: '2.0 2.0 20.0 17.0',
  CategoryAuto: '-0.0 3.0 24.0 18.0',
  CardBasic: '1.5 4.0 21.0 16.0',
  CardInactive: '1.5 4.0 21.0 16.5',
  Expand: '12.0 10.0 12.0 7.0',
  Push: '16.3 6.3 6.7 11.4',
  Collapse: '12.3 9.0 11.4 6.7',
  CommChat: '1.5 4.0 21.0 18.0',
  DepositCheck: '1.0 3.0 22.0 18.0',
  Close: '2.0 2.0 20.0 20.0',
  Clear: '4.0 3.0 16.0 18.0',
  SwapCurrency: '2.5 2.5 19.0 19.0',
  CurrencyUsd: '6.0 1.0 13.0 22.0',
  Download: '3.0 2.0 18.0 19.0',
  Edit: '3.5 3.0 17.5 17.5',
  CommEmail: '2.0 5.0 20.0 15.0',
  LogOut: '3.0 3.0 19.0 18.0',
  Control: '2.0 3.0 20.0 18.0',
  Giftcard: '1.5 1.0 21.0 20.0',
  International: '2.0 2.0 20.0 20.0',
  Like: '2.0 4.0 20.0 17.0',
  Time: '2.0 2.0 20.0 20.0',
  CategoryRent: '1.0 4.0 22.0 17.0',
  InformationOutline: '2.0 2.0 20.0 20.0',
  BitcoinLightning: '4.0 2.0 16.0 20.0',
  Hyperlink: '2.0 2.0 20.0 20.0',
  Location: '3.0 1.0 18.0 21.5',
  LockLocked: '2.5 1.0 19.0 21.5',
  CommSmsFill: '3.0 6.0 18.0 16.4',
  DeviceMobile: '4.5 2.0 15.0 20.0',
  PayLater: '3.0 3.0 18.0 18.0',
  TransferWire: '2.0 3.5 20.0 18.5',
  More: '3.0 10.0 18.0 4.0',
  Notifications: '3.5 2.0 17.0 20.0',
  SensitiveHidden: '2.1 3.5 19.7 17.0',
  SensitiveVisible: '2.1 6.0 19.7 12.0',
  CommPhoneFill: '2.0 2.0 20.0 20.0',
  Data: '2.0 2.0 20.0 20.0',
  Savings: '1.0 1.0 22.0 19.8',
  Avatar: '2.0 2.5 20.0 18.5',
  Refresh: '3.0 1.5 17.0 20.0',
  Refunded: '2.5 4.0 20.0 17.0',
  Search: '3.0 3.0 18.0 18.0',
  Send: '1.0 3.0 20.0 20.0',
  Share: '3.0 2.0 18.0 19.0',
  CategoryShopping: '1.0 3.0 22.0 18.0',
  CardSupport: '1.5 4.0 21.3 18.5',
  AlertReportedFill: '2.0 4.0 20.0 16.0',
  AlertFill: '3.0 3.0 18.0 18.0',
  DiscountTagFill: '2.0 2.0 20.0 20.0',
  DiscountPercentage: '3.5 3.5 17.0 17.0',
  Business: '2.5 6.0 19.0 16.0',
  FavoriteFill: '1.5 1.5 21.0 21.0',
  Favorite: '1.0 1.0 22.0 22.0',
  Copy: '3.0 2.0 18.0 20.0',
  LocationFill: '4.0 3.0 16.0 19.0',
  LocationDuo: '2.0 2.0 20.0 21.0',
  PayInFour: '3.0 3.0 18.0 18.0',
  LinkOut: '3.0 3.0 18.0 18.0',
  CategoryMoving: '1.5 3.0 21.0 19.0',
  Delivery: '-0.0 4.0 24.0 17.0',
  Idea: '4.5 1.0 15.0 21.0',
  AccountVerified: '1.0 1.7 22.0 22.0',
  DiscountTag: '1.5 2.0 20.5 20.5',
  Attach: '4.0 2.0 17.0 20.0',
  TickerLeft: '3.0 5.0 17.0 14.0', // manually added,
  CheckFill: '2.0 2.0 20.0 20.0',
  RecurringAutomatic: '3.0 1.0 18.0 22.0',
  Printer: '2.0 4.5 20.0 17.5',
  Document: '3.4 2.5 17.0 19.0',
  LogoAfterpay: '3.0 4.0 18.0 16.0',
  Check: '2.1 3.1 13.0 10.5',
  CardAdd: '1.5 4.0 21.5 17.0',
  CategoryHealthMedical: '3.0 3.0 19.0 18.5',
  BackCentered: '9.0 6.0 7.0 12.0', // manually added,
  DepositBarcode: '1.0 3.0 22.0 18.0', // manually added,
  FailedFill: '3.0 3.0 18.0 18.0', // manually added,
  TickerRight: '4.0 5.0 17.0 14.0', // manually added
} as const
